import React from "react"
import { Link } from "react-router-dom"
import { navLinks } from "./nav-links"

import styles from "./nav.module.scss"

const FooterNav = () => {
  // Hide Institute and Inspiration tabs in production environment only (not in local or QA)
  const env = process.env.REACT_APP_ENV
  const filteredLinks = env === 'production' 
    ? navLinks.filter(link => link.name !== 'Institute' && link.name !== 'Inspiration')
    : navLinks

  return (
    <nav>
      <ul className={styles.menuWrap}>
        {filteredLinks.map((route, index) => (
          <li className={styles.menuItem} key={index}>
            <Link className="note12r" to={route.path}>
              {route.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default FooterNav
